<div class="card" style="height: 100%;">
  <div class="card-header card-title d-flex">
    <h5 class="m-0 p-0" i18n="@@EnergyConsumptionChartTitle">
      Verbrauch
    </h5>
    <strong style="font-weight: 900; margin-left: auto">
      {{ (this.data.totalDeliveredInWh + this.data.directConsumptionInWh) | kwh:1 }}&nbsp;kWh
    </strong>
  </div>

  <div id="energy-consumption-chart" class="card-body">
    <div *ngIf="isLoading" class="loading-spinner-container" style="margin-top: 80px;">
      <div class="spinner-border text-primary loading-spinner-md" role="status">
        <span class="visually-hidden-focusable" i18n="@@GeneratingChartHint">
          Grafik wird generiert
        </span>
      </div>
    </div>

    <canvas id="energy-consumption-chart-canvas" class="min-height w-100"
      style="display: block; box-sizing: border-box; max-height: 400px; margin: 0 auto;"
      [ngStyle]="{'visibility': !isLoading ? 'visible' : 'hidden'}"></canvas>
  </div>